import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { useDispatch, useSelector } from "react-redux";
import { getMarketDataDetails } from '../../../actions/marketDataAction';
import { UrlPath } from "../../../../config/routeConfig";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import { getMarketDataIndices } from "../../../../config/apiConfig";
import axios from "axios";

import { sbaAxios } from "../../../utils/sbaAxios";
import { Link } from "react-router-dom";
import { ReturnsTab, VamiChart } from "../../../asset/returnsandstatistics/ReturnsTab";
import burgermenu from "../../../asset/returnsandstatistics/images/burger-menu.svg";
import linechartup from "../../../asset/returnsandstatistics/images/line-chart-up-01.svg";
import download from "../../../asset/returnsandstatistics/images/download.svg";
import { exportToExcel } from "../../../utils/excelExporter";
import {
  getReturnsGridDataAction,

  getVamiChartData,

} from "../../../actions/returnsGridAction";
import { getMinMaxReturnDates } from "../../../../config/apiConfig";
import "../marketData/MarketDataDetails.css";
import { getAssetSettings } from '../../../actions/assetSettingsAction';
import moment from "moment";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
export const MarketDataDetails = () => {
  const params = useParams();
  const history = useNavigate();
  let Level = ([{ BreadCrumb: "Market Data >", Routes: `${UrlPath.MarketData}` }]);
  const [marketddldata, setmarketddldata] = useState();
  const [marketlistdata, setmarketlistdata] = useState([]);
  const [marketindexId, setmarketindexId] = useState();
  const Gstate = useSelector(state => { return state; }) || {};
  const isEditable = Gstate.authorizationData.isEditable;
  const dispatch = useDispatch();
  const marketIndexId = params.MarketIndexId ? params.MarketIndexId : 29643;
  const Marketdatadetails = Gstate.Marketdata.Marketdatadetails || [];
  const marketindicesddl = Gstate.Marketdata.Indices || [];
  const [gridView, setGridView] = useState(true);
  const [gridbuttonActive, setGridbuttonActive] = useState(true);
  const [chartbuttonActive, setChartbuttonActive] = useState(false);
  const [chartView, setChartView] = useState(false);
  const [radioValue, setRadioValue] = useState(4);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [gridLoading,setGridLoading]=useState(false);
  useEffect(() => {
    document.title = `Market Data Detail`;
 },[]);
 // const [Marketddetails,setMarketDetails]=useState()
  const ReturnsExcel = useRef();
  useEffect(() => {
    getmarketdataddl();
    dispatch(getMarketDataDetails(params.MarketIndexId));
    getMinMaxValues(params.MarketIndexId);
    dispatch(getAssetSettings(params.MarketIndexId, 3));
  }, []);
  // useEffect(() => {
  //   setMarketDetails(MarketDataDetails);
  // }, [MarketDataDetails]);


  useEffect(() => {
    if (gridbuttonActive)
      dispatch(getReturnsGridDataAction(params.MarketIndexId, 3, new Date().toISOString(), new Date().toISOString(), radioValue));
    else if (!gridbuttonActive)
      dispatch(getVamiChartData(params.MarketIndexId, 3, new Date().toISOString(), new Date().toISOString(), radioValue));
  }, [radioValue]);


  const AssetSettings = useSelector(state => state.assetSettings);
    const ASetting = AssetSettings.assetSetting || {};

    const getmarketdataddl = async () => {
        try {
            const response = await sbaAxios({
                url: `${getMarketDataIndices}`,
                method: 'get',
            });

            setmarketlistdata(response); 
        } catch (error) {
            console.error('Error fetching market data:', error);

           
        }
    };

  useEffect(() => {
    setmarketddldata({ MarketIndexId: Marketdatadetails?.MarketIndexId, MarketIndexName: Marketdatadetails?.MarketIndexName })
  }, [Marketdatadetails])

  const loadmarketdatadetails = () => {
    dispatch(getMarketDataDetails(params.MarketIndexId));
    getMinMaxValues(params.MarketIndexId);
  }

  const marketdatachange = (e) => {
    setGridLoading(true);
    history(`${UrlPath.MarketDataDetails}${e.value.MarketIndexId}`);
    setmarketddldata(e.value)
    setmarketindexId(e.value.MarketIndexId)
    dispatch(getMarketDataDetails(e.value.MarketIndexId));
    dispatch(getAssetSettings(e.value.MarketIndexId, 3));
    getMinMaxValues(e.value.MarketIndexId);
    setTimeout(() => {
      setGridLoading(false);
    }, 1000);
  }

  const editnavigate = () => {

    history(`${UrlPath.MarketDataEdit}${params.MarketIndexId}`);
  }
  const cancelnavigate = () => {
    history(`${UrlPath.MarketData}`);
  }
    const getMinMaxValues = async (marketIndexID) => {
      
        try {
            const response = await sbaAxios({
                url: `${getMinMaxReturnDates}${marketIndexID},${3},${3}`,
                method: 'get',
            });

            const MinMaxDateValue = {
                MinDate: response.StartDate,
                MaxDate: response.EndDate,
            };
            if (MinMaxDateValue.MinDate !== null && MinMaxDateValue.MaxDate !== null) {
                setStartDate(MinMaxDateValue.MinDate);
                setEndDate(MinMaxDateValue.MaxDate);
                dispatch(
                    getReturnsGridDataAction(
                        marketIndexID,
                        3,
                        MinMaxDateValue.MinDate,
                        MinMaxDateValue.MaxDate,
                        radioValue
                    )
                );
                dispatch(
                    getVamiChartData(
                        marketIndexID,
                        3,
                        MinMaxDateValue.MinDate,
                        MinMaxDateValue.MaxDate,
                        radioValue
                    )
                );
            } else {
               
                const currentDate = new Date().toISOString();
                setStartDate(currentDate);
                setEndDate(currentDate);

                dispatch(
                    getReturnsGridDataAction(
                        marketIndexID,
                        3,
                        currentDate,
                        currentDate,
                        currentDate,
                        currentDate,
                        radioValue
                    )
                );
                dispatch(
                    getVamiChartData(
                        marketIndexID,
                        3,
                        MinMaxDateValue.MinDate,
                        MinMaxDateValue.MaxDate,
                        radioValue
                    )
                );
            }
        } catch (error) {
            console.error('Error fetching min/max values:', error);
            
        }
    };

  const ReturnGridValue = () => {
    setGridView(true);
    setChartView(false);
    setGridbuttonActive(true);
    setChartbuttonActive(false);
    getMinMaxValues();

  };

  const ReturnChartValue = () => {
    setGridView(false);
    setChartView(true);
    setGridbuttonActive(false);
    setChartbuttonActive(true);
    dispatch(getVamiChartData(params.MarketIndexId, 3, startDate, endDate, radioValue));
  };
  const getstdYear = (event) => {
    let year = 0;
    switch (event.target.innerText) {
      case "1Y":
        year = 0;
        break;
      case "3Y":
        year = 1;
        break;
      case "5Y":
        year = 2;
        break;
      case "10Y":
        year = 3;
        break;
      case "ITD":
        year = 4;
        break;
    }
    setRadioValue(year);
    //getMinMaxValues();
  };
  // Bottom Grid/Chart end.......
  Level = ([...Level, { BreadCrumb: `${Marketdatadetails?.MarketIndexName}`, Routes: `${UrlPath.MarketDataDetails}${params.MarketIndexId}` }])

  return (<div id="Mkdiv">
    <TopBar label={" Market Data Detail"} />
    <BreadCrumbs Levels={Level} />


    <div class="p-3 bg-white life-science rounded">
      <div class="p-4">
        <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
          <div className="d-flex gap-2 align-items-center">

            <h2 class="fw-medium fs-6 m-0">{Marketdatadetails?.MarketIndexName}</h2>

            <Link title="Market Settings" to={{ pathname: `${UrlPath.MarketDataSettings}${params.MarketIndexId}` }}><i className="fa-solid fa-gear SBA_hand"></i></Link>

          </div>
          <div className="col-lg-9 d-flex gap-1 justify-content-lg-end p-0 align-items-center">
            <div className="w-25 my-2">
              <SBADropDown
                data={marketlistdata}
                textField={'MarketIndexName'}
                dataItemKey={'MarketIndexId'}
                value={marketddldata}
                onChange={marketdatachange}
                filterable={true}
              />

            </div>
            <div>
              <button type="button" className="p-sm-btn mx-1" onClick={()=>{loadmarketdatadetails()}}>Enter</button> 
            </div>
            <div>
              <button type="button" className="p-sm-btn mx-1" onClick={editnavigate} disabled={!isEditable}>Edit</button>

            </div>
            <div>
              <button type="button" className="s-sm-btn mx-1" onClick={cancelnavigate}>Cancel</button>

            </div>
          </div>
        </div>
      </div>
      <div className="row m-0" style={{ margintop: "-5px" }}>
        <div class="col-lg-7 px-0">
          <div class="row detail m-0 p-3">
            <div class="col-md-3">
              <div class="mb-4">
                <span class="fw-medium">Name</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.MarketIndexName}</p>
              </div>
              <div class="mb-4">
                <span class="fw-medium">Symbol</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.MarketIndexShortName}</p>
              </div>

            </div>
            <div class="col-md-3">
              <div class="mb-4">
                <span class="fw-medium">Type</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.MarketIndexType}</p>
              </div>
              <div class="mb-4">
                <span class="fw-medium">Data Source</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.DataSourceName}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-4">
                <label style={{ display: 'flex', alignItems: 'center' }}>
                  <input className="me-1"
                    type="checkbox" id="chktype"
                    checked={Marketdatadetails?.IsPrimary}
                    disabled
                  />
                  <span>Primary</span>
                </label>
              </div>
              <div class="mb-4">
                <span class="fw-medium">Strategy</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.StrategyName}</p>
              </div>
              <div class="mb-4">
                <span class="fw-medium">Notes</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.IndexNotes}</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-4">
                <span class="fw-medium">RFR</span>
                <p class="fw-medium mb-0">{ASetting?.RFR}</p>
              </div>
              <div class="mb-4">
                <span class="fw-medium">MAR</span>
                <p class="fw-medium mb-0">{ASetting?.MAR}</p>
              </div>
              <div class="mb-4">
                <span class="fw-medium">Reporting Group</span>
                <p class="fw-medium mb-0">{Marketdatadetails?.ReportingGroupName}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div>
      <div class="row detail m-0 p-3">
        <div className="row p-3">
          <div className="col-md-6">
            <div className="d-inline-flex ">
              <button
                className={`toggle-btn rounded-start ${gridbuttonActive && "active"
                  }`}
                onClick={() => ReturnGridValue()}
              >
                <span>
                  <img
                    src={burgermenu}
                    alt=""
                    style={{
                      filter: gridbuttonActive
                        ? "brightness(100%)"
                        : "brightness(50%)",
                    }}
                  />
                </span>{" "}
                Grid View
              </button>
              <button
                className={`toggle-btn rounded-end ${chartbuttonActive && "active"
                  }`}
                onClick={() => ReturnChartValue()}
              >
                <span>
                  <img
                    src={linechartup}
                    alt=""
                    style={{
                      filter: chartbuttonActive
                        ? "brightness(100%)"
                        : "brightness(50%)",
                    }}
                  />
                </span>{" "}
                Chart View
              </button>
              <div className="MkYearRG d-flex gap my-auto ms-2">
                <span className="radioSelectorGroup">
                  <div>
                    <span
                      className={
                        radioValue === 0
                          ? "selected YearRadioSpan"
                          : "YearRadioSpan"
                      }
                      onClick={getstdYear}
                    >
                      1Y
                    </span>
                  </div>
                  <div>
                    <span
                      className={
                        radioValue === 1
                          ? "selected YearRadioSpan"
                          : "YearRadioSpan"
                      }
                      onClick={getstdYear}
                    >
                      3Y
                    </span>
                  </div>
                  <div>
                    <span
                      className={
                        radioValue === 2
                          ? "selected YearRadioSpan"
                          : "YearRadioSpan"
                      }
                      onClick={getstdYear}
                    >
                      5Y
                    </span>
                  </div>
                  <div>
                    <span
                      className={
                        radioValue === 3
                          ? "selected YearRadioSpan"
                          : "YearRadioSpan"
                      }
                      onClick={getstdYear}
                    >
                      10Y
                    </span>
                  </div>
                  <div>
                    <span
                      className={
                        radioValue === 4
                          ? "selected YearRadioSpan"
                          : "YearRadioSpan"
                      }
                      onClick={getstdYear}
                    >
                      ITD
                    </span>
                  </div>

                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-flex">
            <div className="ms-auto">
              {!chartbuttonActive && (
                <>
                  <button
                    type="button"
                    className="p-sm-btn"
                    onClick={() => {
                      exportToExcel(ReturnsExcel, "Returns.xlsx");
                    }}
                  >
                    <img src={download} alt="" />
                    Export
                  </button>
                </>
              )}
            </div>
          </div>
        </div>


        {gridbuttonActive === true && (
          <div>
            {gridLoading? <><LoadingScreen/></>:
            <ReturnsTab
              isGridView={gridView}
              ReturnsExcel={ReturnsExcel}
            />}
          </div>
        )}
        {!gridbuttonActive && (
          <div>
            <VamiChart
              isChartView={chartView}
              startDate={startDate}
              endDate={endDate}
              radioValue={radioValue}
            />
          </div>

        )}
      </div>
    </div>
  </div>)
}